// extracted by mini-css-extract-plugin
export var quantityInput = "_hh-0";